import script from "./adminLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./adminLayout.vue?vue&type=script&setup=true&lang=js"

import "./adminLayout.vue?vue&type=style&index=0&id=6d83c9ba&lang=css"

const __exports__ = script;

export default __exports__